import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { useMutation } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'
import { BankingDepositFiscalDocumentValidationSchema } from '../../schemas/bankingDeposits/fiscalDocument.schema'

type UseCreateBankingDepositFiscalDocumentProps = {
  bankingDepositId?: string;
  onSuccess?: (response: AxiosResponse) => void;
  onError?: (error: ErrorResponse) => void;
}

type MutateFnParams = {
  form: BankingDepositFiscalDocumentValidationSchema;
  pdf?: File;
  xml?: File;
}

export const useCreateBankingDepositFiscalDocument = ({
  bankingDepositId,
  onSuccess,
  onError,
}: UseCreateBankingDepositFiscalDocumentProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['createBankingDepositFiscalDocument', bankingDepositId],
    mutationFn: ({ form, pdf, xml }: MutateFnParams) => {
      const payload = {
        fiscal_document: {
          ...form,
          pdf,
          xml,
        }
      }

      return privateAxios.postForm(`/banking/deposits/${bankingDepositId}/fiscal_documents`, payload);
    },
    onSuccess,
    onError,
  });
}
